export function removeRecord(history: HistoryLog, record: RecordEntry): HistoryLog {
  return history.filter((item: RecordEntry) => item.dateTime !== record.dateTime);
}
